module.exports = __webpack_public_path__ + "static/media/dffboys.d68aa378.png";